import React, {useEffect, useMemo, useState} from 'react'
import { HideShow } from './HideShow';
import { TextHideShow } from './TextHideShow';
import { FormattedMessage, useIntl } from 'react-intl';
import { businessTypes } from 'sr/i18n/messages/setting';
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle';
import { usaCities } from 'sr/i18n/messages/setting';
import { employment } from 'app/pages/company/jobpost/component/Jsonalldata';
import { payTypes } from 'sr/i18n/messages/setting';
import { getJobTypeCategory } from 'sr/utils/api/getJobTypeCategory';
import { ModelWrapper } from 'app/pages/company/component/ModelWrapper';
import { Checkbox } from 'sr/helpers';
import getLabelByValue from 'sr/helpers/functions/getLabelByValue';
import { ShowSelected } from './ShowSelected';
export const Filter = ({HandleFilterData}) => {
  const [businessType, setBusinessType] = useState([])
  // const [location, setLocation] = useState([])
  const [jobType, setJobType] = useState([])
  const [empType, setEmpType] = useState([])
  const [payType, setPayType] = useState([])
  const intl = useIntl()
  const [show, setShow] = useState(false)
  const [from, setFrom] = useState()
  const [to, setTo] = useState()
  const [rateRange, setRateRange] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [filterVersion, setFilterVersion] = useState(0);

  const toggleShow = () =>{
        setShow(!show)
    }
    const [jobTypes, setJobTypes] = useState([])
            useEffect(()=>{
              const fetchJobType = async ()=>{
        try {
        const res = await getJobTypeCategory()
        if(res?.success===true){
          setJobTypes(res?.data)
        }
        }
        catch(e:any){
        
        }
              }
              fetchJobType()
            },[])
    useEffect(()=> {
  const filter = {
    business_type:businessType,
    job_type:jobType,
    employment_type:empType, 
    payType:payType,
    createdAt:{
      from:from,
      to:to
    },
    rateRange:rateRange,
    // address:address
  }
  HandleFilterData(filter)
    },[businessType, jobType, empType, payType, from, to, rateRange])
    const HandleRangeData = (props)=> {
      setRateRange(props)
}

const totalapplied = useMemo(() => {
  let count =
    (businessType?.length || 0) +
    (jobType?.length || 0) +
    (empType?.length || 0) +
    (payType?.length || 0);

  if (from) count += 1;
  if (to) count += 1;
  if (rateRange) count += 1;

  return count;
}, [businessType, jobType, empType, payType, from, to, rateRange]);




const handleClear = () => {
  setBusinessType([])
  setJobType([]);
  setEmpType([]);
  setPayType([]);
  setFrom(undefined);
  setTo(undefined);
  setRateRange(undefined);
  setShow(false);
  setShowModal(false);
  setFilterVersion((v) => v + 1); // 👈 force trigger
};

  return (
    <div className='bg-white p-6 rounded-[20px] shadow-sm shadow-slate-300 w-full mb-5'>
      <div className='flex justify-between items-center border-b-[1px] '>
    <div className='font-bold py-4'>
      <FormattedMessage 
      id='CLEANER.JOBS.FILTER.TITLE'
      defaultMessage='All Filter'
      />
    </div>
   {totalapplied>0 &&
    <div className=''>
      <p onClick={()=> setShowModal(true)} className='font-bold text-sm text-[#0078ae] cursor-pointer'>Applied ({totalapplied})</p>
    </div>
}
    {(showModal && totalapplied>0) &&
     <ModelWrapper showModal={showModal}
     HandleModelByProps={()=> setShowModal(false)}
     rounded="rounded-[10px]"
     background="bg-[#00000099]"
     position="absolute max-w-3xl w-4/5 mx-auto"
     opacity="opacity-100"
     topPosition="top-10"
     rightPosition="inset-0"
     width="max-w-[80%] mx-auto"
     >
              <div className="cursor-pointer max-w-3xl w-4/5 mx-auto justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
              >
                            <div className="relative  my-6 w-full h-4/5">
                            <div className='border-0  p-6 rounded-[20px] shadow-sm shadow-slate-300  relative flex flex-col w-full bg-white outline-none focus:outline-none'>
  {/*header*/}
                <div className="flex items-start justify-end rounded-t">
                 
                  
                  
                    <span onClick={handleClear} className="text-sm font-bold  text-[#0078ae] cursor-pointer">
                      Clear All
                    </span>
               
                </div>
<div className='flex flex-wrap'>
<ShowSelected setData={setBusinessType} type={businessType} allTypes={businessTypes}></ShowSelected>
{jobTypes?.length>0 && <ShowSelected setData={setJobType } type={jobType} allTypes={jobTypes}></ShowSelected> }
<ShowSelected setData={setEmpType}  type={empType} allTypes={employment}></ShowSelected>
<ShowSelected setData={setPayType} type={payType} allTypes={payTypes}></ShowSelected>
</div>
<div className=''>
  {Object.keys(rateRange || {})?.length >0 &&
  <p>Rate: <span>${rateRange?.minRange}</span> - <span>${rateRange?.maxRange}</span> </p>
}
</div>
<div className=''>
  {(from || to) &&
  <p>Job Posting Date: <span>{from}</span> 
  {to && <div> - <span>{to}</span> </div> } </p>
}
</div>
               </div> </div>
                </div>
                </ModelWrapper>
}
    </div>
   <HideShow viewmore={businessTypes?.length > 4 ? true : false} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.BUSINESSTYPE', defaultMessage:'Business Type'})} data={businessTypes} newData={businessType}  onChange={(e:any) => CheckBoxHandle(e, businessType, setBusinessType )} />
   {/* <HideShow setAddress={setAddress} name="customlocation" viewmore={true} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.LOCATION', defaultMessage:'Location'})} searchPlaceholder={intl.formatMessage({id:'CLEANER.JOBS.FILTER.LOCATION.SEARCH.PLACEHOLDER', defaultMessage:'Search Location'})} data={usaCities} newData={location} onChange={(e:any)=> CheckBoxHandle(e, location, setLocation)}/> */}
   <HideShow viewmore={employment?.length > 4 ? true : false} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.EMPLOYMENTTYPE', defaultMessage:'Employment Type'})} data={employment} newData={empType} onChange={(e:any)=> CheckBoxHandle(e, empType, setEmpType)}/>
   {jobTypes?.length>0 && <HideShow viewmore={jobTypes?.length > 4 ? true : false} SearchShow = {false} Title ={intl.formatMessage({id:'CLEANER.JOBS.FILTER.JOBTYPE', defaultMessage:'Job Type'})} searchPlaceholder={intl.formatMessage({id:'CLEANER.JOBS.FILTER.JOBTYPE.SEARCH.PLACEHOLDER', defaultMessage:'Search Job Type'})} data={jobTypes} newData={jobType} onChange={(e:any)=> CheckBoxHandle(e, jobType, setJobType)} />}
   <HideShow HandleRangeData={HandleRangeData} name="rate" viewmore={false} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.RATE', defaultMessage:'Rate'})} data={payTypes} onChange={(e:any)=> CheckBoxHandle(e, payType, setPayType)} newData={payType}/>
   <TextHideShow fromValue={from} toValue={to} From={(date)=> setFrom(date)} To={(date)=> setTo(date)}  Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.JOBPOSTINGDATE', defaultMessage:'Job Posting Date'})} />
 
</div>
  )
}
